import { defineComponent as _defineComponent } from 'vue'
import CatalogCategoryItem from '~/components/sections/categorySection/CatalogCategoryItem.vue';

interface Props {
  data: {
    id?: string;
    items: any[];
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogCategories',
  props: {
    data: { default: () => ({
    items: [],
  }) }
  },
  setup(__props: any) {

const sizes: { [size: string]: Record<number, string> } = {
  width: {
    1: 'w-full sm:w-1/3',
    1.5: 'w-full sm:w-1/2',
  },
  height: 'h-[296px] sm:h-[456px]',
};



return { __sfc: true,sizes, CatalogCategoryItem }
}

})